import { Platform } from '@angular/cdk/platform';
import { InjectionToken } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { cloneDeep, isEqual, merge } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/platform";
import * as i2 from "@angular/router";
export var FUSE_CONFIG = new InjectionToken('fuseCustomConfig');
var FuseConfigService = /** @class */ (function () {
    function FuseConfigService(platform, router, config) {
        this.platform = platform;
        this.router = router;
        this._defaultConfig = config;
        this.init();
    }
    Object.defineProperty(FuseConfigService.prototype, "config", {
        get: function () {
            return this.configSubject.asObservable();
        },
        set: function (value) {
            var config = this.configSubject.getValue();
            config = merge({}, config, value);
            this.configSubject.next(config);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FuseConfigService.prototype, "defaultConfig", {
        get: function () {
            return this._defaultConfig;
        },
        enumerable: true,
        configurable: true
    });
    FuseConfigService.prototype.init = function () {
        var _this = this;
        //  Disable custom scrollbars if browser is mobile
        if (this.platform.ANDROID || this.platform.IOS) {
            this._defaultConfig.customScrollbars = false;
        }
        this.configSubject = new BehaviorSubject(cloneDeep(this._defaultConfig));
        // Reload the default layout config on every RoutesRecognized event
        // if the current layout config is different from the default one
        this.router.events
            .pipe(filter(function (event) { return event instanceof RoutesRecognized; }))
            .subscribe(function () {
            if (!isEqual(_this.configSubject.getValue().layout, _this._defaultConfig.layout)) {
                // Clone the current config
                var config = cloneDeep(_this.configSubject.getValue());
                // Reset the layout from the default config
                config.layout = cloneDeep(_this._defaultConfig.layout);
                // Set the config
                _this.configSubject.next(config);
            }
        });
    };
    FuseConfigService.prototype.setConfig = function (value, opts) {
        if (opts === void 0) { opts = { emitEvent: true }; }
        var config = this.configSubject.getValue();
        config = merge({}, config, value);
        if (opts.emitEvent === true) {
            this.configSubject.next(config);
        }
    };
    FuseConfigService.prototype.getConfig = function () {
        return this.configSubject.asObservable();
    };
    FuseConfigService.prototype.resetToDefaults = function () {
        this.configSubject.next(cloneDeep(this._defaultConfig));
    };
    FuseConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseConfigService_Factory() { return new FuseConfigService(i0.ɵɵinject(i1.Platform), i0.ɵɵinject(i2.Router), i0.ɵɵinject(FUSE_CONFIG)); }, token: FuseConfigService, providedIn: "root" });
    return FuseConfigService;
}());
export { FuseConfigService };
